import { FC } from 'react';
import { ErrorBoundary } from '../../components/ErrorBoundary/ErrorBoundary';

export const withErrorBoundary =
  <T extends object = {}>(Component: FC<T>): FC<T> =>
  (props: T) => {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
